import type { TierKey } from "@reach/core";

export const THEME_COLOR = "var(--theme-action-accent)";
export const SHOW_PHASE2_TIERS = false;

export type SettingsTab = {
  id: string;
  content: string;
};

export function getSettingsTabs(planTier: TierKey): SettingsTab[] {
  const tabs: SettingsTab[] = [
    { id: "visual-editor", content: "Appearance & Layout" },
    { id: "assistant", content: "Chatbot" },
    { id: "analytics", content: "Analytics" },
    { id: "plans", content: "Subscription" },
  ];

  if (SHOW_PHASE2_TIERS && planTier === "vea") {
    tabs.splice(2, 0, { id: "designer", content: "Product Designer" });
  }

  return tabs;
}
